import type { IRhizomPageProps } from "@/types/RhizomPageProps/RhizomPageProps";
import { usePage } from "@inertiajs/vue3";
import { computed } from "vue";

export default () => {
    const inertiaProps = usePage<IRhizomPageProps>();
    const teamRoleKey = computed(
        () => inertiaProps.props?.team_role?.key ?? null,
    );

    const isViewer = computed(() => {
        return teamRoleKey.value === "viewer";
    });

    const isEditor = computed(() => {
        return teamRoleKey.value === "editor";
    });

    const isAdmin = computed(() => {
        return teamRoleKey.value === "admin";
    });

    const isOwner = computed(() => {
        return teamRoleKey.value === "owner";
    });

    return {
        isViewer,
        isEditor,
        isAdmin,
        isOwner,
    };
};
